import { defineMessages } from 'react-intl'

export default defineMessages({
  medium: {
    id: 'containers.EmbeddedDealPage.components.Delivery.medium',
    defaultMessage: 'Medium',
  },
  low: {
    id: 'containers.EmbeddedDealPage.components.Delivery.low',
    defaultMessage: 'Low',
  },
  high: {
    id: 'containers.EmbeddedDealPage.components.Delivery.high',
    defaultMessage: 'High',
  },
  urgent: {
    id: 'containers.EmbeddedDealPage.components.Delivery.urgent',
    defaultMessage: 'Urgent',
  },
  english: {
    id: 'containers.EmbeddedDealPage.components.Delivery.english',
    defaultMessage: 'English',
  },
  danish: {
    id: 'containers.EmbeddedDealPage.components.Delivery.danish',
    defaultMessage: 'Danish (HQ)',
  },
  german: {
    id: 'containers.EmbeddedDealPage.components.Delivery.german',
    defaultMessage: 'German',
  },
  purchaseOrder: {
    id: 'containers.EmbeddedDealPage.components.Delivery.purchaseOrder',
    defaultMessage: 'Purchase Order (PO)',
  },
  expected: {
    id: 'containers.EmbeddedDealPage.components.Delivery.expected',
    defaultMessage: 'Expected',
  },
  yes: {
    id: 'containers.EmbeddedDealPage.components.Delivery.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'containers.EmbeddedDealPage.components.Delivery.no',
    defaultMessage: 'No',
  },
  handling: {
    id: 'containers.EmbeddedDealPage.components.Delivery.handling',
    defaultMessage: 'Handling',
  },
  noResults: {
    id: 'containers.EmbeddedDealPage.components.Delivery.noResults',
    defaultMessage: 'No result for',
  },
  searchingFor: {
    id: 'containers.EmbeddedDealPage.components.Delivery.searchingFor',
    defaultMessage: 'Searching for',
  },
  wordCount: {
    id: 'containers.EmbeddedDealPage.components.Delivery.wordCount',
    defaultMessage: 'Word Count',
  },
  playOutMinutes: {
    id: 'containers.EmbeddedDealPage.components.Delivery.playOutMinutes',
    defaultMessage: 'Play Out Minutes',
  },
})
